import { Product } from '@core/models/piramide/Product';
import { Subcategory } from '@core/models/piramide/Subcategory';
import { environment } from '@environments/environment';
import { ReplacePipe } from '@core/pipes/replace.pipe';
import { LiquidationModel } from 'src/app/products/components/liquidation-section/components/liquidation-card/liquidation-card.model';

export class ProductCard {
  public id: number;
  public imageName: string;
  public name: string;
  public decoratedName?: string;
  public subcategory?: Subcategory;
  public price: number;
  public previousPrice?: number;
  public priceList: number;
  public previousPriceList?: number;
  public discount?: number;
  public link: string;
  public liquidation?: LiquidationModel[];
  public stock?: number;
  constructor(product: Product) {
    this.imageName =
      product?.imagenes ?
        product?.imagenes[0]?.nombre
      : environment.apiImageStatic + '/assets/general/sin_foto-mini.jpg';

    this.name = product.nombre;
    this.price = product.precioEspecial ?? product.precioEspecialCombo;
    this.priceList = product.precioLista ?? product.precioListaCombo;
    this.updateDiscountValues(product);
    this.id = product.id_producto;
    this.link = `${new ReplacePipe().transform(product.nombre)}_${product.id_producto}`;
    this.decoratedName = product['decoratedName'];
    this.subcategory = product?.$subcategory;
    this.liquidation = product.$liquidation;
    this.stock = product.stock;
  }

  private updateDiscountValues(product: Product): void {
    this.previousPrice =
      product.id_categoria == 55 && product.precioEspecialCombo ?
        product.precioEspecialCombo
      : product.precioEspecialAnterior;
    this.previousPriceList =
      product.id_categoria == 55 && product.precioListaCombo ?
        product.precioListaCombo
      : product.precioListaAnterior;
    this.discount =
      this.previousPrice != undefined ? this.previousPrice - product.precioEspecial : undefined;
  }
}
